export const CLIENT_TYPE = {
    WEB: "web",
    NATIVE: "native",
};
export const NATIVE_SESSION_ABSOLUTE_CAP_SECONDS = 90 * 24 * 60 * 60;
export const NATIVE_SESSION_CAP_WARNING_SECONDS = 24 * 60 * 60;
export const SESSION_CAP_REACHED = "session-cap-reached";
export const SESSION_REVOKED = "session-revoked";
//# sourceMappingURL=auth.js.map